if (!customElements.get('inventa-ean-search')) {
  customElements.define('inventa-ean-search', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const { signal } = this.lifecycle;
      this.scope = this.closest('.inventa-search');
      try { this.messages = JSON.parse(this.querySelector('[data-ean-messages]').textContent); }
      catch { return; }
      this.scope.addEventListener('inventa:discovery-rendered', () => this.refresh(), { signal });
      window.addEventListener('pageshow', () => this.refresh(), { signal });
      this.refresh();
    }
    refresh() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.hidden = true;
      this.querySelector('[data-inventa-product-grid]').replaceChildren();
      const nativeEmpty = this.scope.querySelector('[data-native-search-empty]');
      if (nativeEmpty) nativeEmpty.hidden = false;
      const emptyHelp = this.scope.querySelector('[data-search-empty-help]');
      if (emptyHelp) emptyHelp.hidden = false;
      this.load(this.controller.signal);
    }
    disconnectedCallback() { this.controller?.abort(); this.lifecycle?.abort(); }
    async load(signal) {
      const code = this.dataset.query.trim();
      if (!/^(\d{8}|\d{12}|\d{13}|\d{14})$/.test(code)) return;
      const params = new URLSearchParams(location.search);
      // EAN matches are separate from native facets; never imply they obey selected filters.
      if ([...params.keys()].some(key => key.startsWith('filter.')) || Number(params.get('page') || 1) > 1) return;
      const status = this.querySelector('[data-ean-status]');
      const list = this.querySelector('[data-inventa-product-grid]');
      list.replaceChildren();
      this.hidden = false;
      status.textContent = this.messages.loading;
      try {
        const endpoint = new URL(this.dataset.endpoint, location.origin);
        endpoint.searchParams.set('q', code);
        const response = await fetch(endpoint, { signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('lookup');
        const data = await response.json();
        if (!Array.isArray(data.handles)) throw new Error('payload');
        let failed = false;
        // Small batches avoid a request burst for EANs shared by several products.
        for (let offset = 0; offset < Math.min(data.handles.length, 20); offset += 4) {
          const cards = await Promise.all(data.handles.slice(offset, offset + 4).map(async handle => {
            if (!/^[a-z0-9-]+$/.test(handle)) return null;
            const url = new URL(`${this.dataset.root}products/${handle}`, location.origin);
            const alreadyVisible = [...this.scope.querySelectorAll('[data-inventa-product-card] a[href]')]
              .some(link => !this.contains(link) && new URL(link.href, location.origin).pathname === url.pathname);
            if (alreadyVisible) return null;
            url.searchParams.set('section_id', 'inventa-ean-card');
            if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
            try {
              const result = await fetch(url, { signal, credentials: 'same-origin' });
              if (result.status === 404) return null;
              if (!result.ok) throw new Error('card');
              const doc = new DOMParser().parseFromString(await result.text(), 'text/html');
              const wrapper = doc.querySelector('[data-ean-product]');
              if (wrapper?.dataset.eanProduct !== handle) return null;
              const card = wrapper.querySelector('[data-inventa-product-card]');
              if (!card) throw new Error('card markup');
              const item = document.createElement('li');
              item.className = 'inventa-product-grid__item';
              item.setAttribute('data-inventa-product-item', '');
              item.append(document.importNode(card, true));
              return item;
            } catch (error) { if (error.name === 'AbortError') throw error; failed = true; return null; }
          }));
          if (signal.aborted) return;
          const inserted = cards.filter(Boolean);
          list.append(...inserted);
          if (inserted.length) document.dispatchEvent(new CustomEvent('inventa:wishlist-buttons-added'));
        }
        const count = list.children.length;
        const nativeEmpty = this.scope.querySelector('[data-native-search-empty]');
        if (nativeEmpty && count) nativeEmpty.hidden = true;
        const emptyHelp = this.scope.querySelector('[data-search-empty-help]');
        if (emptyHelp && count) emptyHelp.hidden = true;
        status.textContent = count
          ? [(count === 1 ? this.messages.one : this.messages.many).replace('[count]', count), data.truncated ? this.messages.more : '', failed ? this.messages.partial : ''].filter(Boolean).join(' ')
          : failed ? this.messages.failed : this.messages.empty;
      } catch (error) {
        if (error.name !== 'AbortError' && !signal.aborted) status.textContent = this.messages.error;
      }
    }
  });
}
